import React from 'react';
import { get } from 'lodash';

// React view component to render
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { memberHealthInfo as MemberHealthInfoView } from 'ui/views/widgets/memberHealthInfo';
import { MemberHealthInfoService } from 'services/memberHealthInfo';

// React view component to render

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { MemberHealthInfo } from 'ui/containers/MemberHealthInfo';
 *
 * // render
 * <MemberHealthInfo propName='propValue'/>
 */
export class MemberHealthInfo extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );
        this.fetchGeneration = 0;
        this.fetchActive = true;

        // component state
        this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
        };

        // Member Info Settings Service
        this.memberHealthInfoService = new MemberHealthInfoService();

        // Member Info Settings data fetch
        this.fetchComponentData();
    }

    /**************************************************** */

    /**
     * @desc Fetch member Info Settings.
     */
    async fetchComponentData() {
       
        log.debug( 'MemberInfoSettings.fetchComponentData()' );

        const generation = ++this.fetchGeneration;
        // cancel ongoing request
        this.memberHealthInfoService.cancel();

        try {
            const { status, data }  = await this.memberHealthInfoService.fetchData( {
                url: this.props.widget.url
                
                // data: this.props.requestPayload,
            } );

            if( ! this.fetchActive || generation !== this.fetchGeneration ) return;

            // check if response status was success
            if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
                this.setState( () => this.fetchActive && generation === this.fetchGeneration ? ( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
                } ) : null );
            } else {
                this.setState( () => this.fetchActive && generation === this.fetchGeneration ? ( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                    componentData: data,
                } ) : null );
            }

        } catch( e ) {
            if( ! this.fetchActive || generation !== this.fetchGeneration ) return;
            this.setState( () => this.fetchActive && generation === this.fetchGeneration ? ( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE,
            } ) : null );
        }
    }

    /*********************************************/

    /**
     * @desc When component unmounts, cleanup resources.
     */
    componentWillUnmount() {
        this.fetchActive = false;
        this.fetchGeneration++;
        this.memberHealthInfoService.cancel(); // cancel ongoing requests
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <MemberHealthInfoView
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                { ...get( this.state, 'componentData', {} ) }
                requestPayload={ this.props.requestPayload }
            />
        );
    }
}

// set display name
MemberHealthInfo.displayName = 'MemberHealthInfo';

// set default props
MemberHealthInfo.defaultProps = {};

// prop types
MemberHealthInfo.propTypes = {};
